import { useEffect, useRef } from "react";

/**
 * Hook untuk membuat modal lebih fleksibel dan modern:
 * - Menutup modal saat klik di luar panel (backdrop click)
 * - Menutup modal saat tekan tombol Escape
 *
 * Cara pakai:
 *   const panelRef = useModalDismiss(onClose)            // selalu aktif
 *   const panelRef = useModalDismiss(onClose, isOpen)    // aktif hanya saat isOpen
 *
 *   <div ref={panelRef} className="modal-panel-enter ...">...</div>
 */
export default function useModalDismiss(onClose, isOpen = true) {
  const ref = useRef(null);

  useEffect(() => {
    if (!isOpen) return;

    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        onClose?.();
      }
    };

    const handleMouseDown = (e) => {
      // Abaikan klik kanan dan klik tengah
      if (e.button !== 0) return;
      // Jika klik tepat di dalam panel modal, jangan tutup
      if (ref.current && ref.current.contains(e.target)) return;
      // Hindari menutup saat klik mengenai dropdown/overlay anak (mis. select option)
      // dengan memastikan target masih ada di DOM (popover sebagian dilepas saat klik)
      if (!document.body.contains(e.target)) return;
      onClose?.();
    };

    document.addEventListener("keydown", handleKeyDown);
    // Pakai mousedown agar lebih responsif & tidak konflik dengan onClick anak
    document.addEventListener("mousedown", handleMouseDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("mousedown", handleMouseDown);
    };
  }, [isOpen, onClose]);

  return ref;
}
